export {version as default} from '../package.json';



//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/version.js
// module id = Ecs/
// module chunks = 0